
export default {
  computed: {
    locais() {
      return [
        {
          icon: "mdi-phone",
          text: this.fixo  || '--',
          title: "Telefone fixo",
        },
        {
          icon: "mdi-cellphone-iphone",
          text: this.celular,
          title: "Celular",
        },
        {
          icon: "mdi-whatsapp",
          text: this.whatsapp,
          title: "Whatsapp",
        },
        {
          icon: "mdi-cellphone-iphone",
          text: this.celular_2 || "nenhum",
          title: "Celular 2",
        },
        {
          icon: "mdi-account",
          text: this.dono_celular_2 || "nenhum",
          title: "Dono do Celular 2",
        },
        {
          icon: "mdi-email-outline",
          text: this.email,
          title: "e-mail",
        },
      ];
    },
  },
  props: {
    fixo: String,
    celular: String,
    whatsapp: String,
    celular_2: String,
    dono_celular_2: String,
    email: String,
  },
};
